import React, { useEffect } from 'react'
import { Route, Routes } from 'react-router-dom'
import '../admin/style.css'
import Dashboard from './dashboard/Dashboard'
import AddCate from './function/AddCate'
import AddProduct from './function/AddProduct'
import Products from './function/categories/Products'
import Auth from '../components/auth/Auth'
import ProtectedRoute from '../protected-route/ProtectedRoute'
import Orders from './function/orders/Orders'
import Categories from './function/categories/Categories'
import './Control.css'
import { useAppDispatch, useAppSelector } from '../store'
import { fetchAllCategoriesAPI } from '../redux/reducers/categoryReducers'
import { fetchProductsAPI } from '../redux/actions/productActions'
import { getOrdersUserAPI } from '../redux/actions/orderActions'

function Admin() {
  // const { path, url } = useRouteMatch()
  const user = useAppSelector(state => state.user)
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(fetchProductsAPI())
    dispatch(fetchAllCategoriesAPI())
    dispatch(getOrdersUserAPI())
  }, [dispatch])
  return (
    <div className="admin">
      <Dashboard url={'url'} />
      <h1 style={{ marginTop: '20px', marginBottom: '20px' }}>
        Wellcome {user.user ? user.user.username : 'anonymous'}
      </h1>
      <Routes>
        <Route path="/logout" element={<Auth authRoute={''} />} />
        {/* <Route path={`${ path }/orders`} element={<Orders />} />
        <Route path={`${ path }/cate`} element={<Categories />} /> */}
        {/* <Route element={<ProtectedRoute />}>

          <Route
            path={`${ path }/products`}
            element={<Products />}
          />
          <Route
            path={`${ path }/new-product`}
            element={<AddProduct />}
          />
          <Route path={`${ path }/new-cate`} element={<AddCate />} />
        </Route> */}
      </Routes>
    </div>
  )
}

export default Admin
